import { deleteHttp } from "../../../common/api/apiShared.ts";
import { useState } from "react";
import { useParams } from "react-router";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { FrameworkTemplateCategoriesViewModel, FrameworkTemplateCategoryViewModel } from "./FrameworkTemplateCategories.types.ts";
import { useDotLegalQuery, useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useFrameworkTemplateCategories() {
    const snackbar = useDotLegalSnackbar();

    const { id } = useParams<{ id: string }>();
    const [showDialog, setShowDialog] = useState(false);
    const [showDeleteCategory, setShowDeleteCategory] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState<FrameworkTemplateCategoryViewModel>();

    const url = `/frameworks/templates/${id}/categories`;
    const { isLoading, data, refetch } = useDotLegalQuery<FrameworkTemplateCategoriesViewModel>(url);

    const deleteMutation = useDotLegalMutation(deleteCategoryApi);
    const onDeleteClick = async () => {
        await deleteMutation.mutateAsync(selectedCategory!.id, {
            onSuccess: (response: any) => {
                const deleteResponse = response.value();
                if (deleteResponse.isDeleted) {
                    snackbar.show(`The category '${selectedCategory!.languages[0].name}' was deleted`, "success");
                    setShowDeleteCategory(false);
                    setSelectedCategory(undefined);
                    refetch();
                } else {
                    snackbar.show(`The category '${selectedCategory!.languages[0].name}' could not be deleted because it is in use on a control`, "warning");
                    setShowDeleteCategory(false);
                    setSelectedCategory(undefined);
                }
            },
        });
    };

    function onSelectCategory(id: string) {
        var category = data?.categories.find((x) => x.id === id);

        if (category) {
            setSelectedCategory(category);
        }
    }

    return {
        id,
        isLoading,
        data,
        showDialog,
        setShowDialog,
        selectedCategory,
        setSelectedCategory,
        showDeleteCategory,
        setShowDeleteCategory,
        refetch,
        onDeleteClick,
        onSelectCategory,
    };

    function deleteCategoryApi(categoryId: string) {
        return deleteHttp(`/frameworks/templates/${id!}/categories/${categoryId}`);
    }
}
